import styled, { css } from 'styled-components';

import mq from './breakpoints';
import Spacings from './Spacings';

export default {
  primaryButtonPosition: css`
    ${mq.to.breakpoint.M`
      width: 100%;
      box-sizing: border-box;
      justify-content: center;
    `}
  `,
  secondaryButtonPosition: css`
    padding-bottom: ${Spacings.XS};

    ${mq.from.breakpoint.M`
      padding-bottom: initial;
    `}

    ${mq.to.breakpoint.L`
      box-sizing: border-box;
    `}
  `,
};

export const CtaWrapper = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  gap: ${Spacings.M};
  margin-top: ${Spacings.L};
  width: 100%;

  ${mq.to.breakpoint.L`
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  `}
`;
